import { Style } from './style';

const EmptyState = ({ t }) => (
  <Style>
    <div className='row-a'>
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
    </div>
    <div className='row-b'>
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
      <div className='item' />
    </div>
    <div className='message'>
      <h5>{t('No Data')}</h5>
      <p>{t('Invite new sources to join your project to populate Data Consolidation Chart.')}</p>
    </div>
  </Style>
);

export default EmptyState;
